var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.ShowHideCron == 0) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.ShowHideCron = '1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus plus"
  }), _vm._v(" SVC Cron Job Run/ Search   "), _c('span', {
    staticStyle: {
      "font-size": "13px",
      "margin-left": "28%"
    }
  }, [_c('b', [_vm._v("( Today Date : APP >> " + _vm._s(_vm.appDate) + "    ||    API >> " + _vm._s(_vm.apiDate) + " )")])])]) : _vm._e(), _vm._v(" "), (_vm.ShowHideCron == 1) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.ShowHideCron = '0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus minus"
  }), _vm._v(" SVC Cron Job   "), _c('span', {
    staticStyle: {
      "font-size": "13px",
      "margin-left": "36%"
    }
  }, [_c('b', [_vm._v("( Today Date : APP >> " + _vm._s(_vm.appDate) + "    ||    API >> " + _vm._s(_vm.apiDate) + " )")])])]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    class: ("" + (_vm.ShowHideCron == '1' ? 'show' : 'hide')),
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Cron Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "crondate",
      "type": "date",
      "name": "crondate"
    },
    model: {
      value: (_vm.crondate),
      callback: function($$v) {
        _vm.crondate = $$v
      },
      expression: "crondate"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "cd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Cron Hub Ids "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubids),
      expression: "hubids"
    }],
    ref: "textarea",
    class: {
      'form-control': true
    },
    attrs: {
      "rows": "2",
      "name": "hubids",
      "id": "hubids",
      "placeholder": "Enter Hub Ids..."
    },
    domProps: {
      "value": (_vm.hubids)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hubids = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only accept comma (,) separated hub ids.")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "text-danger",
    attrs: {
      "id": "chi"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.runLoading
    },
    on: {
      "update:active": function($event) {
        _vm.runLoading = $event
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getCronStatus()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search Failed Cron Hub Ids")]), _vm._v("\n                  "), _c('b', [_vm._v("|")]), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cronSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Run Cron")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetCron()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")]), _c('br'), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Note: * For Search Failed Cron Hub Ids, no need to fill 'Cron Hub Ids' input field & For Run Cron, no need to fill 'Cron Date' input field.")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.cronLoading
    },
    on: {
      "update:active": function($event) {
        _vm.cronLoading = $event
      }
    }
  }), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Failed Cron Hub Ids")]), _vm._v("  "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("(" + _vm._s(_vm.cronrundate) + ")")])])])])]), _vm._v(" "), _c('tbody', [(_vm.cronDiffCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("All cron records found")])]) : _vm._e(), _vm._v(" "), (_vm.cronDiffCount > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.cronDiffList))])]) : _vm._e()])], 1), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "margin-top": "2%"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.hubidLoading
    },
    on: {
      "update:active": function($event) {
        _vm.hubidLoading = $event
      }
    }
  }), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("All Cron Hub Ids")]), _vm._v("  "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("(" + _vm._s(_vm.hubarrlength) + ")")])])])])]), _vm._v(" "), _c('tbody', [(_vm.hubarrlength == 0) ? _c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.hubarrlength > 0) ? _c('tr', [_c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.hubidarr))])]) : _vm._e()])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.ShowHideFilter == 0) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.ShowHideFilter = '1'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus plus"
  }), _vm._v(" AWB Difference Search\n        ")]) : _vm._e(), _vm._v(" "), (_vm.ShowHideFilter == 1) ? _c('div', {
    staticClass: "card-header filter_main",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.ShowHideFilter = '0'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus minus"
  }), _vm._v(" AWB Difference Search\n        ")]) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    class: ("" + (_vm.ShowHideFilter == '1' ? 'show' : 'hide')),
    attrs: {
      "id": "collapse1"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Delivery Date "), _c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("*")])], 1), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-calendar'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('deliverydate')
    },
    attrs: {
      "id": "deliverydate",
      "type": "date",
      "name": "deliverydate"
    },
    model: {
      value: (_vm.deliverydate),
      callback: function($$v) {
        _vm.deliverydate = $$v
      },
      expression: "deliverydate"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('deliverydate')),
      expression: "errors.has('deliverydate')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Delivery date is required. ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "44px"
    },
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.allZoneLoading
    },
    on: {
      "update:active": function($event) {
        _vm.allZoneLoading = $event
      }
    }
  }), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zone),
      expression: "zone"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "44px"
    },
    attrs: {
      "name": "zone",
      "id": "zone"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.zone = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getHubData]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Select--")]), _vm._v(" "), _vm._l((_vm.zoneList), function(zone_obj) {
    return _c('option', {
      domProps: {
        "value": zone_obj.hubzoneid
      }
    }, [_vm._v(_vm._s(zone_obj.hubzonename))])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Hub Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-list'></i>"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "mini-spinner",
      "color": "#FF6700",
      "active": _vm.hubLoading
    },
    on: {
      "update:active": function($event) {
        _vm.hubLoading = $event
      }
    }
  }), _vm._v(" "), _c('Multiselect', {
    staticStyle: {
      "border": "1px solid #c2cfd6",
      "z-index": "999"
    },
    attrs: {
      "options": _vm.hubList,
      "name": "HubId",
      "id": "HubId",
      "placeholder": "Select Hub",
      "label": "HubName",
      "track-by": "HubID",
      "optionHeight": 100,
      "hide-selected": true
    },
    model: {
      value: (_vm.HubId),
      callback: function($$v) {
        _vm.HubId = $$v
      },
      expression: "HubId"
    }
  }, [_c('template', {
    slot: "noResult"
  }, [_c('p', [_vm._v("No Record Found.")])])], 2)], 1), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Note: Please select Hub Name after Zone.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Hub Ids to Check AWB Difference")]), _vm._v(" "), _c('b-input-group', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbhubids),
      expression: "awbhubids"
    }],
    ref: "textarea",
    class: {
      'form-control': true
    },
    attrs: {
      "rows": "2",
      "name": "awbhubids",
      "id": "awbhubids",
      "placeholder": "Enter Hub Ids..."
    },
    domProps: {
      "value": (_vm.awbhubids)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbhubids = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only accept comma (,) separated hub ids.")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": function($event) {
        _vm.resetForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v(" Clear")])])])])])], 1)]), _vm._v(" "), (_vm.awbhubids) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" SU & DB Result Count For Multiple Hubs  "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("(" + _vm._s(_vm.allddate) + ")")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [(_vm.allSUList) ? _c('tr', [_vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("COD Count:  " + _vm._s(_vm.allSUList.SUtotal) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Cash Count:  " + _vm._s(_vm.allSUList.SUcashCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Card Count:  " + _vm._s(_vm.allSUList.SUcardCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Payphi Count:  " + _vm._s(_vm.allSUList.SUpayphiCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Wallet Count:  " + _vm._s(_vm.allSUList.SUwalletCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Razorpay Count:  " + _vm._s(_vm.allSUList.SUrazorpayCnt) + "\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    HDFC Count:  " + _vm._s(_vm.allSUList.SUHDFCCnt) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.allDBList) ? _c('tr', [_vm._m(2), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("COD Count:  " + _vm._s(_vm.allDBList.DBTotalCODCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Cash Count:  " + _vm._s(_vm.allDBList.DBCODcashCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Card Count:  " + _vm._s(_vm.allDBList.DBCODcardCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Payphi Count:  " + _vm._s(_vm.allDBList.DBCODpayphiCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Wallet Count:  " + _vm._s(_vm.allDBList.DBCODwalletCnt) + ",\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    Razorpay Count:  " + _vm._s(_vm.allDBList.DBCODrazorpayCnt) + "\n                  "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("    HDFC Count:  " + _vm._s(_vm.allDBList.DBCODHDFCCnt) + "\n              ")])]) : _vm._e()])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  AWB Difference Result  "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("(" + _vm._s(_vm.HubNm) + "  :  " + _vm._s(_vm.closuredate) + ")")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(3), _vm._v(" "), _c('tbody', [(_vm.resultDiffCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.resultDiffCount > 0) ? _c('tr', [_vm._m(4), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("Difference Count:  " + _vm._s(_vm.DiffList.TotalCODdiffCnt) + ",  "), _c('b', [_vm._v("||")]), _vm._v("  Difference Amount:  " + _vm._s(_vm.DiffList.CODdiffAmt))])]) : _vm._e(), _vm._v(" "), (_vm.resultDiffCount > 0) ? _c('tr', [_vm._m(5), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DiffList.CODdiffArr))])]) : _vm._e()])])], 1)]), _vm._v(" "), (_vm.resultSUCount > 0 || _vm.resultDBCount > 0) ? _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" SU & DB Result Count  "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("(" + _vm._s(_vm.HubNm) + "  :  " + _vm._s(_vm.closuredate) + ")")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(6), _vm._v(" "), _c('tbody', [(_vm.resultSUCount > 0) ? _c('tr', [_vm._m(7), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("COD Count:  " + _vm._s(_vm.SUList.TotalCODCnt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Cash Count:  " + _vm._s(_vm.SUList.CODcashCnt) + ",  Cash Amount:  " + _vm._s(_vm.SUList.CODCashAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Card Count:  " + _vm._s(_vm.SUList.CODcardCnt) + ",  Card Amount:  " + _vm._s(_vm.SUList.CODcardAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Payphi Count:  " + _vm._s(_vm.SUList.CODpayphiCnt) + ",  Payphi Amount:  " + _vm._s(_vm.SUList.CODpayphiAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Wallet Count:  " + _vm._s(_vm.SUList.CODwalletCnt) + ",  Wallet Amount:  " + _vm._s(_vm.SUList.CODwalletAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Razorpay Count:  " + _vm._s(_vm.SUList.CODrazorpayCnt) + ",  Razorpay Amount:  " + _vm._s(_vm.SUList.CODrazorpayAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  HDFC Count:  " + _vm._s(_vm.SUList.CODHDFCCnt) + ",  HDFC Amount:  " + _vm._s(_vm.SUList.CODHDFCAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Prepaid Count:  " + _vm._s(_vm.SUList.CODprepaidCnt) + "\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.resultDBCount > 0) ? _c('tr', [_vm._m(8), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v("COD Count:  " + _vm._s(_vm.DBList.DBTotalCODCnt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Cash Count:  " + _vm._s(_vm.DBList.DBCODcashCnt) + ",  Cash Amount:  " + _vm._s(_vm.DBList.DBCODCashAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Card Count:  " + _vm._s(_vm.DBList.DBCODcardCnt) + ",  Card Amount:  " + _vm._s(_vm.DBList.DBCODcardAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Payphi Count:  " + _vm._s(_vm.DBList.DBCODpayphiCnt) + ",  Payphi Amount:  " + _vm._s(_vm.DBList.DBCODpayphiAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Wallet Count:  " + _vm._s(_vm.DBList.DBCODwalletCnt) + ",  Wallet Amount:  " + _vm._s(_vm.DBList.DBCODwalletAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Razorpay Count:  " + _vm._s(_vm.DBList.DBCODrazorpayCnt) + ",  Razorpay Amount:  " + _vm._s(_vm.DBList.DBCODrazorpayAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  HDFC Count:  " + _vm._s(_vm.DBList.DBCODHDFCCnt) + ",  HDFC Amount:  " + _vm._s(_vm.DBList.DBCODHDFCAmt) + ",\n                    "), _c('b', {
    staticStyle: {
      "font-size": "large"
    }
  }, [_vm._v("||")]), _vm._v("  Prepaid Count:  " + _vm._s(_vm.DBList.DBCODprepaidCnt) + "\n                ")])]) : _vm._e()])])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Shipment Update Result  "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("(" + _vm._s(_vm.HubNm) + "  :  " + _vm._s(_vm.closuredate) + ")")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(9), _vm._v(" "), _c('tbody', [(_vm.resultSUCODCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.SUList.CODcashCnt > 0) ? _c('tr', [_vm._m(10), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.SUList.cashArr))])]) : _vm._e(), _vm._v(" "), (_vm.SUList.CODcardCnt > 0) ? _c('tr', [_vm._m(11), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.SUList.cardArr))])]) : _vm._e(), _vm._v(" "), (_vm.SUList.CODpayphiCnt > 0) ? _c('tr', [_vm._m(12), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.SUList.payphiArr))])]) : _vm._e(), _vm._v(" "), (_vm.SUList.CODwalletCnt > 0) ? _c('tr', [_vm._m(13), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.SUList.walletArr))])]) : _vm._e(), _vm._v(" "), (_vm.SUList.CODrazorpayCnt > 0) ? _c('tr', [_vm._m(14), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.SUList.razorpayArr))])]) : _vm._e(), _vm._v(" "), (_vm.SUList.CODHDFCCnt > 0) ? _c('tr', [_vm._m(15), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.SUList.HDFCArr))])]) : _vm._e()])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  DB Result  "), _c('span', {
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('b', [_vm._v("(" + _vm._s(_vm.HubNm) + "  :  " + _vm._s(_vm.closuredate) + ")")])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(16), _vm._v(" "), _c('tbody', [(_vm.resultDBCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), (_vm.DBList.DBCODcashCnt > 0) ? _c('tr', [_vm._m(17), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DBList.DBcashArr))])]) : _vm._e(), _vm._v(" "), (_vm.DBList.DBCODcardCnt > 0) ? _c('tr', [_vm._m(18), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DBList.DBcardArr))])]) : _vm._e(), _vm._v(" "), (_vm.DBList.DBCODpayphiCnt > 0) ? _c('tr', [_vm._m(19), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DBList.DBpayphiArr))])]) : _vm._e(), _vm._v(" "), (_vm.DBList.DBCODwalletCnt > 0) ? _c('tr', [_vm._m(20), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DBList.DBwalletArr))])]) : _vm._e(), _vm._v(" "), (_vm.DBList.DBCODrazorpayCnt > 0) ? _c('tr', [_vm._m(21), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DBList.DBrazorpayArr))])]) : _vm._e(), _vm._v(" "), (_vm.DBList.DBCODHDFCCnt > 0) ? _c('tr', [_vm._m(22), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.DBList.DBHDFCArr))])]) : _vm._e()])])], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("SU & DB AWB Number Count For Multiple Hubs")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("SU")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("DB")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("AWB Number Count & Amount")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("COD Difference")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("COD AWB No")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("SU & DB AWB Number Count & Amount")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("SU")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("DB")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("AWB Numbers")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Cash")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Card")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Payphi")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Wallet")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Razorpay")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("HDFC")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "colspan": "2"
    }
  }, [_c('b', [_vm._v("AWB Numbers")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Cash")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Card")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Payphi")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Wallet")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Razorpay")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("HDFC")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e814478","hasScoped":true}!./src/views/components/awbdifference/awbdifference.component.html
// module id = 700
// module chunks = 1